function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { SET_DASHBOARD_DATA } from "./actionTypes.js";
import { getDashboardData, getPluginDataMapForDashboard } from "./selectors.js";
/**
 * Action to replace the dashboard data for a dashboard
 * @param id The ID of the dashboard to set the data on
 * @param data Data for the dashboard
 * @returns The action to get dispatched
 */
export var setDashboardData = (id, data) => ({
  type: SET_DASHBOARD_DATA,
  id,
  payload: data
});

/**
 * Action to update the dashboard data. Will combine the update with any existing dashboard data.
 * @param id The id of the dashboard to update the data on
 * @param updateData The data to combine with the existing dashboard data
 * @returns
 */
export var updateDashboardData = (id, data) => (dispatch, getState) => dispatch(setDashboardData(id, _objectSpread(_objectSpread({}, getDashboardData(getState(), id)), data)));

/**
 * Action to set the dashboard plugin data.
 * Will replace any existing plugin data for the plugin in the dashboard with the data provided.
 * @param id The id of the dashboard to set the data on
 * @param pluginId The id of the plugin to set the data on
 * @param data The data to replace the existing plugin data with
 * @returns Thunk action to dispatch
 */
export var setDashboardPluginData = (id, pluginId, data) => (dispatch, getState) => dispatch(setDashboardData(id, _objectSpread(_objectSpread({}, getDashboardData(getState(), id)), {}, {
  pluginDataMap: _objectSpread(_objectSpread({}, getPluginDataMapForDashboard(getState(), id)), {}, {
    [pluginId]: data
  })
})));
//# sourceMappingURL=actions.js.map